import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { QRCodeModule } from 'angularx-qrcode';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { AuthCallbackComponent } from '../components/auth/auth-callback/auth-callback.component';
import { LoginComponent } from '../components/auth/login/login.component';
import { LogoutCallbackComponent } from '../components/auth/logout-callback/logout-callback.component';
import { MfaSetupComponent } from '../components/auth/mfa/mfa.component';
import { RequestNewPasswordComponent } from '../components/auth/request-new-password/request-new-password.component';
import { SetNewPasswordComponent } from '../components/auth/set-new-password/set-new-password.component';
import { SignUpComponent } from '../components/auth/sign-up/sign-up.component';
import { UnauthorisedComponent } from '../components/auth/unauthorised/unauthorised.component';
import { BannerMessageComponent } from '../components/banner-message/banner-message.component';
import { FullPageMaskComponent } from '../components/full-page-mask/full-page-mask.component';
import { PopupMessageComponent } from '../components/popup-message/popup-message.component';
import { TabularSelectComponent } from '../components/tabular-select/tabular-select.component';
import { WizardButtonsComponent } from '../components/wizard-buttons/wizard-buttons.component';
import { DisableControlDirective } from '../directives/control-disable.directive';
import { ControlUppercaseDirective } from '../directives/control-uppercase.directive';
import { FormLabelNameDirective } from '../directives/form-controls/form-label-name.directive';
import { FormMessageNameDirective } from '../directives/form-controls/form-message-name.directive';
import { OnlyNumberDirective } from '../directives/form-controls/form-number.directive';
import { SpinnerDirective, SpinnerModule } from '../directives/spinner.directive';
import { TabularSelectTriggerForDirective } from '../directives/tabular-select/tabular-select-trigger-for.directive';
import { CardValueFormatterPipe } from '../pipes/card-value-formatter.pipe';
import { StringArrayToHtmlListPipe } from '../pipes/string-array-to-html-list.pipe';
import { YesNoFormatterPipe } from '../pipes/yes-no-from-boolean.pipe';
import { MaterialModule } from './material.module';
import { RootLayoutModule } from 'root-layout';

@NgModule({
  declarations: [
    LoginComponent,
    RequestNewPasswordComponent,
    SetNewPasswordComponent,
    AuthCallbackComponent,
    UnauthorisedComponent,
    LogoutCallbackComponent,
    FullPageMaskComponent,
    FormLabelNameDirective,
    FormMessageNameDirective,
    OnlyNumberDirective,
    MfaSetupComponent,
    BannerMessageComponent,
    PopupMessageComponent,
    SignUpComponent,
    StringArrayToHtmlListPipe,
    CardValueFormatterPipe,
    TabularSelectComponent,
    TabularSelectTriggerForDirective,
    WizardButtonsComponent,
    YesNoFormatterPipe,
    ControlUppercaseDirective,
    DisableControlDirective,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    QRCodeModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    SpinnerModule,
    RootLayoutModule,
  ],
  exports: [
    FormLabelNameDirective,
    FormMessageNameDirective,
    OnlyNumberDirective,
    FullPageMaskComponent,
    MfaSetupComponent,
    BannerMessageComponent,
    StringArrayToHtmlListPipe,
    CardValueFormatterPipe,
    TabularSelectComponent,
    TabularSelectTriggerForDirective,
    WizardButtonsComponent,
    SpinnerDirective,
    YesNoFormatterPipe,
    ControlUppercaseDirective,
    DisableControlDirective,
  ],
})
export class CommonCoreModule {}
